import React from 'react';
import { motion } from 'framer-motion';
interface SectionHeaderProps {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  align?: 'left' | 'center';
  className?: string;
}
export function SectionHeader({
  eyebrow,
  title,
  subtitle,
  align = 'center',
  className = ''
}: SectionHeaderProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.5,
    ease: 'easeOut'
  }} className={`flex flex-col ${align === 'center' ? 'items-center text-center' : 'items-start text-left'} ${className}`} data-id="element-221">
      {eyebrow && <span className="text-[10px] md:text-sm font-bold tracking-wider text-teal-700 uppercase mb-2 md:mb-3" data-id="element-222">
          {eyebrow}
        </span>}
      <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold leading-tight mb-3 md:mb-4 text-teal-900" data-id="element-223">
        {title}
      </h2>
      {subtitle && <p className="text-sm md:text-xl text-slate-600 max-w-3xl leading-relaxed" data-id="element-224">
          {subtitle}
        </p>}
    </motion.div>;
}